import * as React from 'react';
import { ActionLink, Body1, UIHeading3 } from '@cian/ui-kit';

import { FactRow } from '../../../AiSummaryModalDesktop/parts/Content/parts/factsRows';
import { PeculiarityRow } from '../../../AiSummaryModalDesktop/parts/Content/parts/peculiarityRows';
import type {
  IAiSummaryEmptyState,
  IAiSummaryNewbuilding,
  IAiSummaryResponse,
} from '../../../AiSummaryModalDesktop/types';
import { FooterBlock } from './parts/FooterBlock';
import { NoDataBlock } from './parts/NoDataBlock';
import * as styles from './styles.css';

export interface IMobileContentProps {
  summary: IAiSummaryNewbuilding;
  emptyState: IAiSummaryEmptyState;
  disclaimer: IAiSummaryResponse['disclaimer'];
  call?: React.ReactNode;
  chat?: React.ReactNode;
}

export const MobileContent = ({
  summary,
  emptyState,
  disclaimer,
  call,
  chat,
}: IMobileContentProps): React.JSX.Element => {
  const hasHighlights = Boolean(summary.highlights?.items.length);
  const hasFeatures = Boolean(summary.features?.items.length);

  return (
    <div className={styles['container']}>
      <div className={styles['building-container']}>
        <div className={styles['title-container']}>
          <ActionLink color="default" fontSize="XL" fontWeight="bold">
            {summary.name}
          </ActionLink>
          {summary.priceRange && <Body1>{summary.priceRange}</Body1>}
        </div>
        <div className={styles['call-container']}>
          {call}
          {chat}
        </div>
      </div>
      {!hasHighlights ? (
        <NoDataBlock {...emptyState} isFullContent={true} />
      ) : (
        <>
          <div className={styles['facts-container']} key={summary.id}>
            <UIHeading3>{summary.highlights?.title}</UIHeading3>
            <div className={styles['facts-row-wrapper']}>
              {summary.highlights?.items.map(item => (
                <FactRow {...item} isMobile key={item.title} />
              ))}
            </div>
            {hasFeatures && (
              <>
                <UIHeading3>{summary.features?.title}</UIHeading3>
                <div className={styles['facts-row-wrapper']}>
                  {summary.features?.items.map(item => (
                    <PeculiarityRow {...item} isMobile key={item.title} />
                  ))}
                </div>
              </>
            )}
          </div>
          {!hasFeatures && <NoDataBlock {...emptyState} isFullContent={false} />}
        </>
      )}
      {hasHighlights && hasFeatures && <FooterBlock {...disclaimer} />}
    </div>
  );
};
